import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

const useRemoveTransport = (transportId: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<void>({
    path: `/api/businesses/${business.id}/transports/${transportId}`,
    method: HttpMethod.DELETE,
  }, options);
}

export default useRemoveTransport;
